export default "__VITE_ASSET__B4el3jav__"